import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [blurNsfw, setBlurNsfw] = useState(() => {
        const saved = localStorage.getItem('blurNsfw');
        return saved !== null ? JSON.parse(saved) : true;
    });

    const [onlyNsfw, setOnlyNsfw] = useState(() => {
        const saved = localStorage.getItem('onlyNsfw');
        return saved !== null ? JSON.parse(saved) : false;
    });

    const [mediaVolume, setMediaVolume] = useState(() => {
        const saved = localStorage.getItem('mediaVolume');
        const volume = saved === null || saved.trim() === '' ? NaN : Number(saved);
        return Number.isFinite(volume) && volume >= 0 && volume <= 1 ? volume : 1;
    });

    const [cardSize, setCardSize] = useState(() => {
        const saved = localStorage.getItem('cardSize');
        return ['compact', 'standard', 'large'].includes(saved) ? saved : 'standard';
    });

    useEffect(() => {
        localStorage.setItem('cardSize', cardSize);
    }, [cardSize]);

    useEffect(() => {
        localStorage.setItem('mediaVolume', String(mediaVolume));
    }, [mediaVolume]);

    useEffect(() => {
        localStorage.setItem('blurNsfw', JSON.stringify(blurNsfw));
    }, [blurNsfw]);

    useEffect(() => {
        localStorage.setItem('onlyNsfw', JSON.stringify(onlyNsfw));
    }, [onlyNsfw]);

    return (
        <SettingsContext.Provider value={{ blurNsfw, setBlurNsfw, onlyNsfw, setOnlyNsfw, mediaVolume, setMediaVolume, cardSize, setCardSize }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
